import {mapActions, mapGetters} from 'vuex'

export const profileMixin = {
  computed: {
    ...mapGetters({
      'profileUser': 'profile/user'
    })
  },
  methods: {
    ...mapActions({
      'getCurrentUser': 'profile/getProfileUser'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/profileMixin.js